var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderReach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1004 4.5C11.1004 6.70914 9.30479 8.5 7.08981 8.5C4.87482 8.5 3.07923 6.70914 3.07923 4.5C3.07923 2.29086 4.87482 0.5 7.08981 0.5C9.30479 0.5 11.1004 2.29086 11.1004 4.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.08975 7.5C3.31259 7.5 0.249941 10.0309 0.0712891 13.2163C0.0712891 13.3691 0.224392 13.5 0.403126 13.5H13.7765C13.9552 13.5 14.1083 13.3691 14.1083 13.2163C13.9294 10.031 10.8667 7.5 7.08975 7.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderReach);
export default __webpack_public_path__ + "static/media/headerReach.3268d0329465da9c55c17d0fe43c91d7.svg";
export { ForwardRef as ReactComponent };